import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import { CardView, rem, Spacer } from 'design-system';
import StockChartView from './StockChartView';
import useStockChart from '../hooks/useStockChart';
import StockInfoView from './StockInfoView';
const StockChart = ({ has1DChart, assetId }) => {
    const { requesting, dataSet, selectedInfoObj, selectedPeriod, setSelectedPeriod } = useStockChart(assetId, has1DChart);
    return (<CardView style={styles.card} noMarginBottom>
      <Spacer h={16}/>
      <StockInfoView assetId={assetId} selectedInfoObj={selectedInfoObj} selectedPeriod={selectedPeriod} priceTrend={dataSet[selectedPeriod]?.priceTrend} priceChangeValue={dataSet[selectedPeriod]?.priceChangeValue} defaultTimeStamp={dataSet[selectedPeriod]?.defaultTimeStamp || ''}/>
      <Spacer h={4}/>
      <StockChartView has1DChart={has1DChart} requesting={requesting} selectedPeriod={selectedPeriod} selectedInfoObj={selectedInfoObj} dataObj={dataSet[selectedPeriod]} setSelectedPeriod={setSelectedPeriod}/>
    </CardView>);
};
const styles = StyleSheet.create({
    card: {
        overflow: 'visible',
        marginBottom: rem(8),
    },
});
export default memo(StockChart);
